// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
// 引入element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
// 引入路由
import router from "./router";
// 引入状态管理
import store from "./vuex/store";
// 引入icon
import "./assets/icon/iconfont.css";
import "@/assets/style/index.css";
import "@/assets/style/password-eye.css";
//
import "@/utils/fiexible.js";

// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import { Axios } from "./utils/axios";
Vue.prototype.$https = Axios;

import DictTag from "@/components/DictTag";
import Dialog from "@/components/Dialog";
import {
  getDictLabel,
  getDictOptions,
  getIntDictOptions,
  getDictItem,
  ensureDictCache,
  loadDictCache,
  clearDictCache,
  DICT_TYPE
} from "@/utils/dict";

Vue.component("DictTag", DictTag);
Vue.component("Dialog", Dialog);
Vue.prototype.$dict = {
  DICT_TYPE,
  getDictLabel,
  getDictOptions,
  getIntDictOptions,
  getDictItem,
  ensureDictCache,
  loadDictCache,
  clearDictCache
};

import settings from "@/settings";

document.title = settings.title;
Vue.prototype.$settings = settings;

Vue.config.productionTip = false;

Vue.use(VueCompositionAPI);
// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from "./utils/util";

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
});

import {
  loadDynamicRoutes,
  isDynamicRoutesLoaded,
  getDefaultRoutePath
} from "@/utils/dynamicRoutes";
import { getToken } from "@/utils/token";

// 路由拦截器
router.beforeEach(async (to, from, next) => {
  if (to.path === "/login") {
    next();
    return;
  }

  const token = getToken();
  if (!token) {
    next({ path: "/login", replace: true });
    return;
  }

  if (!isDynamicRoutesLoaded()) {
    try {
      const loaded = await loadDynamicRoutes();
      if (!loaded) {
        next({ path: "/login", replace: true });
        return;
      }
      // addRoutes 后必须重新进入目标路由；用 replace 避免历史栈多一条
      next({ ...to, replace: true });
      return;
    } catch (e) {
      next({ path: "/login", replace: true });
      return;
    }
  }

  if (!to.matched.length) {
    const fallback = getDefaultRoutePath() || "/home";
    // 已在目标页却未匹配时，避免 next(同 path) 触发 Redirected 报错
    if (to.path === fallback) {
      next();
      return;
    }
    next({ path: fallback, replace: true });
    return;
  }

  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store, //使用store vuex状态管理
  components: { App },
  template: "<App/>",
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
});



// WEBPACK FOOTER //
// ./src/main.js